const BRAND_ROW = 30;
const TITLE = 46;
const VOLUME_FOOTER = 30;
const CARD_PADDING = 10;

const CHART = 90;
const CHART_PADDING = 18;

const ODDS_ROW = 30;
const ODDS_ROW_GAP = 6;
const ODDS_PADDING = 14;
const ODDS_COLUMNS = 2;

const MIN_WIDTH = 260;
const MIN_WIDTH_TWO_COLUMNS = 340;

export interface IEmbedMinSizeParams {
  chart: boolean;
  odds: boolean;
  consensusOnly: boolean;
  selectionCount: number;
  isConsensusMode: boolean;
}

export interface IEmbedSize {
  height: number;
  width: number;
}

export const getEmbedOddsColumns = (platformRowCount: number): number =>
  platformRowCount > 1 ? ODDS_COLUMNS : 1;

const getPlatformRowCount = ({
  consensusOnly,
  selectionCount,
  isConsensusMode,
}: IEmbedMinSizeParams): number =>
  isConsensusMode && consensusOnly ? 0 : selectionCount;

const getOddsRowCount = (params: IEmbedMinSizeParams): number => {
  const platformRowCount = getPlatformRowCount(params);
  const columns = getEmbedOddsColumns(platformRowCount);

  return (
    Math.ceil(platformRowCount / columns) + (params.isConsensusMode ? 1 : 0)
  );
};

export const getEmbedMinSize = (params: IEmbedMinSizeParams): IEmbedSize => {
  let height = BRAND_ROW + TITLE + VOLUME_FOOTER + CARD_PADDING;
  let width = MIN_WIDTH;

  if (params.chart) {
    height += CHART + CHART_PADDING;
  }

  if (params.odds) {
    const rowCount = getOddsRowCount(params);

    height +=
      rowCount * ODDS_ROW +
      ODDS_ROW_GAP * Math.max(0, rowCount - 1) +
      ODDS_PADDING;

    if (getEmbedOddsColumns(getPlatformRowCount(params)) > 1) {
      width = MIN_WIDTH_TWO_COLUMNS;
    }
  }

  return { height, width };
};
